import React, { Component } from "react";
import { API } from "aws-amplify";
import { Form, Container, Row, Col, Button } from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import {FiArrowLeft} from "react-icons/fi";
import "./SleepEntries.css";
import duration from "../duration";

export default class SleepEntries extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sleepStart: "",
      sleepEnd: "",
      sleepRating: "",
      timesAwake: "",
      sleepDate: "",
      sleepNote: "",
      sleepDuration: "",
      initalSleepStart: "",
      initialSleepEnd: "",
      isLoading: false,
    };
  }

  async componentDidMount() {
    try {
      const entry = await this.getSleepEntry();
      const { sleepStart, sleepEnd, sleepRating, timesAwake, sleepDate, sleepNote, sleepDuration } = entry;

      this.setState({
        sleepStart,
        sleepEnd,
        sleepRating,
        timesAwake,
        sleepDate,
        sleepNote, 
        sleepDuration
      });
      this.setState({ initalSleepStart: this.state.sleepStart});
      this.setState({ initialSleepEnd: this.state.sleepEnd});
    } catch (e) {
      alert(e);
    }
  }

  getSleepEntry() {
    return API.get("sleep", `/sleep/${this.props.match.params.id}`);
  }

  saveSleepEntry(updatedEntry) {
    return API.put("sleep", `/sleep/${this.props.match.params.id}`, {
      body: updatedEntry
    });
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleSubmit = async event => {
    event.preventDefault();
    this.setState({ isLoading: true });
    let currentDuration = this.state.sleepDuration;
    if(this.state.sleepStart !== this.state.initalSleepStart || this.state.sleepEnd !== this.state.initialSleepEnd)
    {
      currentDuration = duration.calculateDuration(this.state.sleepStart, this.state.sleepEnd);
    }
    try {
      await this.saveSleepEntry({
        sleepStart: this.state.sleepStart,
        sleepEnd: this.state.sleepEnd,
        sleepRating: this.state.sleepRating,
        timesAwake: this.state.timesAwake,
        sleepDate: this.state.sleepDate,
        sleepNote: this.state.sleepNote,
        sleepDuration: currentDuration
      });
      this.props.history.push(`${process.env.PUBLIC_URL}/`);
    } catch (e) {
      alert(e);
      this.setState({ isLoading: false });
    }
  }

  handleDelete = async event => {
    event.preventDefault();

    const confirmed = window.confirm(
      "Are you sure you want to delete this sleep entry?"
    );

    if (!confirmed) {
      return;
    }

    this.setState({ isDeleting: true });
    try {
      await this.deleteSleepEntry();
      this.props.history.push(`${process.env.PUBLIC_URL}/`);
    } catch (e) {
      alert(e);
      this.setState({ isDeleting: false });
    }
  }

  deleteSleepEntry() {
    return API.del("sleep", `/sleep/${this.props.match.params.id}`);
  }

  validateForm() {
    let startForm = this.state.sleepStart.length !== "";
    let endForm = this.state.sleepEnd.length !== "";
    let ratingForm = !isNaN(this.state.sleepRating);
    let awakeForm = !isNaN(this.state.timesAwake);
    let dateForm = this.state.sleepDate !== "";
    let result = (startForm && endForm && ratingForm && awakeForm && dateForm) === true;
    return result;
  }

  render() {
    return (
      <div>
          <Button className="backBtn" onClick={() => this.props.history.push(`${process.env.PUBLIC_URL}/`)}><FiArrowLeft></FiArrowLeft></Button>
        <div className="SleepEntry">
          {this.state.sleepStart &&
            <form onSubmit={this.handleSubmit}>

              <Container>
                <Row>
                  <Col className="sleepStartCol">
                    <Form.Group controlId="sleepStart">
                      <Form.Label>Sleep Start</Form.Label>
                      <Form.Control
                        onChange={this.handleChange}
                        value={this.state.sleepStart}
                        type="time"
                      />
                    </Form.Group>
                  </Col>
                  <Col className="sleepEndCol">
                    <Form.Group controlId="sleepEnd">
                      <Form.Label>Sleep End</Form.Label>
                      <Form.Control
                        onChange={this.handleChange}
                        value={this.state.sleepEnd}
                        type="time"
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Container>
              <Form.Group controlId="sleepRating">
                <Form.Label>Sleep Rating</Form.Label>
                <Form.Control
                  onChange={this.handleChange}
                  value={this.state.sleepRating}
                  type="number"
                />
              </Form.Group>
              <Form.Group controlId="timesAwake">
                <Form.Label>Times Awake</Form.Label>
                <Form.Control
                  onChange={this.handleChange}
                  value={this.state.timesAwake}
                  type="number"
                />
              </Form.Group>
              <Form.Group controlId="sleepDate">
                <Form.Label>Sleep Date</Form.Label>
                <Form.Control
                  onChange={this.handleChange}
                  value={this.state.sleepDate}
                  type="date"
                />
              </Form.Group>
              <Form.Group controlId="sleepNote">
                <Form.Label>Notes</Form.Label>
                <Form.Control
                  onChange={this.handleChange}
                  value={this.state.sleepNote}
                  as="textarea"
                  rows="3"
                />
              </Form.Group>
              <LoaderButton
                block
                disabled={!this.validateForm()}
                type="submit"
                isLoading={this.state.isLoading}
                text="Update"
                className="entryBtn"
                loadingText="Saving…"
              />
              <LoaderButton
                block
                isLoading={this.state.isDeleting}
                onClick={this.handleDelete}
                text="Delete"
                className="entryBtn"
                loadingText="Deleting…"
              />
            </form>}
        </div>
      </div>
    )

  }
}
